import moment from 'moment-timezone'
import React, { useCallback } from 'react'
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

import useFormatToOrgTime from 'Event/scenes/events/hooks/useFormatToOrgTime'
import { getSlots } from 'Event/scenes/events/helpers/volunteerSlots'
import { EventDiffConflict } from 'Event/hooks/useCompareEvents'
import { Opportunity } from 'Event/interfaces'

interface EventListConflictTableProps {
  conflicts: EventDiffConflict[]
}

interface DiffCellProps {
  lhs: string
  rhs: string | undefined
}

const useStyles = makeStyles({
  empty: {
    textAlign: 'center',
    padding: '24px',
    color: '#999',
    fontStyle: 'italic',
  },
  errorRow: {
    background: '#d32f2f transparent',
  },
})

export const EventListConflictTable: React.FC<EventListConflictTableProps> = ({
  conflicts,
}: EventListConflictTableProps) => {
  const classes = useStyles()
  const formatTime = useFormatToOrgTime()

  const DiffCell = useCallback(
    ({ lhs, rhs }: DiffCellProps) => {
      return lhs == rhs ? (
        <TableCell>{lhs}</TableCell>
      ) : (
        <TableCell className={classes.errorRow}>
          {lhs} | {rhs}
        </TableCell>
      )
    },
    [classes],
  )

  if (!conflicts || conflicts.length === 0) {
    return <div className={classes.empty}>No conflicts</div>
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>ID</TableCell>
          <TableCell>Opp ID</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Start</TableCell>
          <TableCell>End</TableCell>
          <TableCell>Roles</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {conflicts.map(({ event, rawEvent }, idx) => {
          const slots = event.slots || getSlots(event as unknown as Opportunity)
          const rawSlots = getSlots(rawEvent as unknown as Opportunity)

          return (
            <TableRow key={idx}>
              <DiffCell lhs={`${event.occurrenceId}`} rhs={`${rawEvent.occurrenceId}`} />
              <TableCell>{event.opportunityId}</TableCell>
              <TableCell>{moment(event.startsAt).format('M/D/YY')}</TableCell>
              <DiffCell lhs={event.name} rhs={rawEvent.name} />
              <DiffCell lhs={formatTime(event.startsAt)} rhs={formatTime(rawEvent.startsAt)} />
              <DiffCell lhs={formatTime(event.endsAt)} rhs={formatTime(rawEvent.endsAt)} />
              <DiffCell
                lhs={`${slots.total - slots.available} / ${slots.total}`}
                rhs={`${rawSlots.total - rawSlots.available} / ${rawSlots.total}`}
              />
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
